var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEstacionCargaDentro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#168e16;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-estacion-carga-dentro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia",
    "data-name": "38 copia"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.2,156.23c-6.14,0-12.32-3.56-12.32-11.51,0-4.11,2.36-7.18,4.26-9.65.29-.38.59-.76.86-1.14,1.93-2.62,3.38-5.06,3.39-5.08l2.18-3.67a1.88,1.88,0,0,1,3.18-.09l2.38,3.54s1.89,2.8,3.84,5.56l.44.62c1.89,2.64,4.24,5.93,4.24,10.25C118.65,151.85,113.76,156.23,106.2,156.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.08,76.55H88.71a3.31,3.31,0,0,0-3.31,3.32v24.95a3.32,3.32,0,0,0,3.31,3.32h35.37a3.32,3.32,0,0,0,3.32-3.32V79.87A3.31,3.31,0,0,0,124.08,76.55Zm-3.31,25H92V83.18h28.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.75,86.78H170.23a5,5,0,0,0-3.77,1.39,5.05,5.05,0,0,0-1.07,4.12c0,.38.06.78.06,1.22v39.32c0,1.13-.3,6.74-6.12,6.74-6.08,0-7.36-3.76-7.36-6.92V119.48c0-1.33,0-3.55-1.63-5.19a5.13,5.13,0,0,0-3.75-1.47h-5.18v-52a3.32,3.32,0,0,0-3.32-3.31H74.53a3.32,3.32,0,0,0-3.32,3.31V167.54H58a3.32,3.32,0,1,0,0,6.63h95.88a3.32,3.32,0,1,0,0-6.63H141.41V119.45h3.93v13.19c0,6.25,3.66,13.55,14,13.55,10.08,0,12.75-8.74,12.75-13.37V93.42h11.67a3.32,3.32,0,0,0,0-6.64ZM77.85,64.15h56.92V167.43H77.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstacionCargaDentro);
export default __webpack_public_path__ + "static/media/ic-estacion-carga-dentro.3cdd74ad63d553cf34d37afe7b089eb7.svg";
export { ForwardRef as ReactComponent };